var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrlurl"},[_c('v-text-field',_vm._b({attrs:{"label":_vm.schema.label,"append-icon":_vm.icono,"readonly":!_vm.edicion},on:{"click:append":_vm.show_url},model:{value:(_vm.schema.value),callback:function ($$v) {_vm.$set(_vm.schema, "value", $$v)},expression:"schema.value"}},'v-text-field',_vm.$input,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }